import { combineReducers } from "redux";
import { selectedMovieReducer, featuredMovieReducer, mainMovieReducer, heroMovieReducer, watchlistReducer } from "./movieReducer";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['watchlistMovie']
}

const reducers = combineReducers({
    movie: selectedMovieReducer,
    // allMovies: featuredMovies, mainMovies,
    featuredMovies: featuredMovieReducer,
    mainMovies: mainMovieReducer,
    heroMovie: heroMovieReducer,
    watchlistMovie: watchlistReducer,
    // selectedBadge: badgeReducer,
})

export default persistReducer(persistConfig, reducers);









// import { combineReducers } from "redux";
// import { selectedMovieReducer, featuredMovieReducer, mainMovieReducer, heroMovieReducer, watchlistReducer, badgeReducer } from "./movieReducer";

// const reducers = combineReducers({
//     movie: selectedMovieReducer,
//     // allMovies: featuredMovies, mainMovies,
//     featuredMovies: featuredMovieReducer,
//     mainMovies: mainMovieReducer,
//     heroMovie: heroMovieReducer,
//     watchlistMovie: watchlistReducer,
//     // selectedBadge: badgeReducer,
// })

// export default reducers;